export default function BadgeWithImage({
  image,
  title,
}: {
  image: React.ReactNode;
  title: string;
}) {
  return (
    <div className="flex flex-row gap-2 rounded-full items-center bg-[#353535] border border-[#474545] px-2 pr-3 py-1">
      {image}
      {title}
    </div>
  );
}
